import userUtils from 'utils/User';
import { matchContexts } from 'analytics/utils/cmsComponents';

const buildTrendingOffersSotFields = personalization => {
    if (!Sephora.configurationSettings?.p13ntrendingNBO?.isEnabled || !userUtils.isAnonymous() || !personalization?.isTrendingOffersEnabled) {
        return null;
    }

    const p13nData = matchContexts(personalization);
    const toABTestId = personalization?.trendingOffersABTest?.[0]?.abTestId || '';

    return `trendingOffersEnabled:true;to_ABTest:${!!p13nData?.isAbTest};to_isDefault:${!!p13nData?.isDefault};to_isControl:${!!p13nData?.isControl};to_ABTestId:${toABTestId}`;
};

export { buildTrendingOffersSotFields };
